import { Suspense } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { AuthenticationProvider, useConfigProvider } from "melco-shared-logic";
import { RestoreToken } from "./RestoreToken";

//import "melco-ui/dist/melcoUI.css";
import "./fonts.css";
import "./App.css";
import { useCurrentProductVariant } from "./hooks/useCurrentProductVariant";
import { MELCO_CLOUD } from "./helper/commonHelper";
import { useAppDomain } from "./hooks/appdomain/useAppDomain";
import { MainBerninaLogin } from "./MainBerninaLogin";
import { ConfigProvider } from "melco-ui";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 0,
    },
  },
});



export const App: React.FC = () => {
  //const { t } = useTranslation();
  const productVariant = useCurrentProductVariant();
  const { appTitle } = useAppDomain()
  document.title = appTitle;
  const configProviderProps = useConfigProvider();
  return (
    <Suspense fallback={null}>
      <ConfigProvider {...configProviderProps}>
      <QueryClientProvider client={queryClient}>
        <AuthenticationProvider>
          {productVariant === MELCO_CLOUD ? (
            <RestoreToken />
          )
            : (
              <MainBerninaLogin />
              // <RestoreTokenBernina />
            )
          }
        </AuthenticationProvider>
     
      </QueryClientProvider>
    </ConfigProvider>
    </Suspense>
  );
}
